import { render, staticRenderFns } from "./sendEmail.vue?vue&type=template&id=fd8b09e6&scoped=true"
import script from "./sendEmail.vue?vue&type=script&lang=js"
export * from "./sendEmail.vue?vue&type=script&lang=js"
import style0 from "./sendEmail.vue?vue&type=style&index=0&id=fd8b09e6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd8b09e6",
  null
  
)

export default component.exports